import { flexRender, HeaderGroup } from "@tanstack/react-table"
import { ReactElement } from "react"
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"
import { twMerge } from "tailwind-merge"

export type HeaderCell = {
	Header: string
	accessor: string
	disableSortBy?: boolean
	disableGlobalFilter?: boolean
}

export type TableHeaderProps<T> = {
	headerGroups: HeaderGroup<T>[]
	columnsLayout?: string
	columnsLayoutStyle?: string
	className?: string
}

export function TableHeader<T>(props: TableHeaderProps<T>): ReactElement {
	return (
		<>
			{props.headerGroups.map((headerGroup) => (
				<div
					key={headerGroup.id}
					style={{ gridTemplateColumns: props.columnsLayoutStyle }}
					className={twMerge(
						`grid min-h-12.5 py-1 select-none ${
							props.columnsLayout ?? ""
						} text-tiny border-dipai-text-disabled gap-4 border-t-1 bg-white px-4 leading-[12px] font-bold tracking-[0.5px]`,
						props.className
					)}
				>
					{headerGroup.headers.map((header, idx) => (
						<div
							key={header.id}
							id={`table-header-${header.id}`}
							className={`${
								props.headerGroups.length > 1 &&
								idx !== headerGroup.headers.length - 1 &&
								(header.isPlaceholder === false ||
									headerGroup.headers[idx + 1]?.isPlaceholder === false) &&
								headerGroup.depth === 0
									? "border-r-1 pr-0.75"
									: "pr-1"
							}`}
							style={{ gridColumn: `span ${header.subHeaders.length}` }}
						>
							<div
								className={`flex h-full flex-row items-center ${
									header.column.getCanSort() === true
										? `cursor-pointer select-none`
										: ``
								}`}
								onClick={header.column.getToggleSortingHandler()}
							>
								<span
									className={`min-h-4 ${
										header.column.getIsSorted() === "desc" ||
										header.column.getIsSorted() === "asc"
											? "text-dipai-text-highlight"
											: "text-dipai-text-primary"
									} ${header.column.getCanSort() === true ? "hover:text-dipai-text-highlight" : ""} col-span-3 w-full py-1`}
								>
									{header.isPlaceholder === true
										? null
										: flexRender(
												header.column.columnDef.header,
												header.getContext()
											)}
								</span>
								<div className="text-dipai-text-highlight -mt-0">
									{header.column.getIsSorted() === "desc" ? (
										<MdKeyboardArrowDown className="size-5" />
									) : header.column.getIsSorted() === "asc" ? (
										<MdKeyboardArrowUp className="size-5" />
									) : null}
								</div>
							</div>
						</div>
					))}
				</div>
			))}
		</>
	)
}
